import { ReactNode, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { ChecksRequired } from 'components/Signup/ProductOffers/ChecksRequired/ChecksRequired';
import { OffersError } from 'components/Signup/ProductOffers/OffersError/OffersError';
import { OffersLoader } from 'components/Signup/ProductOffers/OffersLoader/OffersLoader';
import { useNumberFormat } from 'hooks/useNumberFormat';
import sharedStyles from '../TradingHistory.module.css';
import titleStyles from '../TradingHistoryTitle/TradingHistoryTitle.module.css';
import { DocumentRequirements } from './DocumentRequirements/DocumentRequirements';
import { SubmitDocuments } from './SubmitDocuments';
import styles from './TradingHistory.module.css';
import { getLoanDurationRange } from './TradingHistoryDE.helpers';
import { useDETradingHistoryPage } from './useDETradingHistoryPage/useDETradingHistoryPage';

type TProps = { backButton?: ReactNode };

export const TradingHistoryDE = ({ backButton }: TProps) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCheckingRequirements, setIsCheckingRequirements] = useState(false);

  const {
    isLoadingPage,
    isLoadingOffersAndRelatedData,
    isSecurityCheckRequired,
    signupError,
    documentRequirements,
    requestedDuration,
    requestedAmount,
  } = useDETradingHistoryPage();
  const { formatCurrency } = useNumberFormat();

  if (isLoadingOffersAndRelatedData && !isCheckingRequirements) {
    return (
      <div className={sharedStyles.contentWrapper}>
        <OffersLoader />
      </div>
    );
  }

  if (signupError) {
    return (
      <div className={sharedStyles.contentWrapper}>
        <OffersError error={signupError} />
      </div>
    );
  }

  if (isSecurityCheckRequired) {
    return (
      <div className={sharedStyles.contentWrapper}>
        <ChecksRequired />
      </div>
    );
  }
  const durationMonths = getLoanDurationRange(requestedDuration);
  const formattedAmount = formatCurrency(requestedAmount);

  return (
    <>
      {backButton}
      <div className={clsx(sharedStyles.tradingHistory, styles.container)}>
        <div className={titleStyles.headingContainer}>
          <h1
            data-testid="trading-history-title"
            className={titleStyles.heading}
          >
            {formattedAmount && durationMonths ? (
              <Trans>
                You're requesting a loan of <strong>{formattedAmount}</strong>{' '}
                over a duration of <strong>{durationMonths}</strong>
              </Trans>
            ) : (
              <Trans>loading...</Trans>
            )}
          </h1>

          <p className={titleStyles.mainSubHeading}>
            {isLoadingPage
              ? t`Loading your required documents...`
              : t`Required documents`}
          </p>
        </div>
        {documentRequirements && (
          <DocumentRequirements
            documentRequirements={documentRequirements}
            isSubmitted={isSubmitted}
          />
        )}
        <SubmitDocuments
          isSubmitted={isSubmitted}
          setIsSubmitted={setIsSubmitted}
          setIsCheckingRequirements={setIsCheckingRequirements}
        />
      </div>
    </>
  );
};
